import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { theme } from '../../styles/theme';
import Logo1 from '../../assets/images/PORTAL_LOGO.png';
const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Logo = styled(Link)`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${theme.colors.primary};
  text-decoration: none;
  // height: 100px;
`;

const NavLinks = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  align-items: center;

  @media (max-width: ${theme.breakpoints.sm}) {
    display: none;
  }
`;

const MobileMenu = styled.div`
  display: none;
  
  @media (max-width: ${theme.breakpoints.sm}) {
    display: block;
  }
`;

const NavLink = styled(Link)`
  color: ${theme.colors.text.primary};
  text-decoration: none;
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  transition: all 0.2s ease-in-out;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  &.active {
    color: ${theme.colors.primary};
    background: ${theme.colors.primary}10;
  }
`;

const LogoutButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.error};
  cursor: pointer;
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${theme.colors.error}10;
  }
`;

const Navigation = () => {
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem('adminToken');

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/login');
  };

  return (
    <Nav className='' style={{backgroundColor:'#065f60'}}>
      <Logo to="/"> <img src={Logo1} alt="Wisdom Sprouts Logo" style={{ width: '40%', height: 'auto' }} /></Logo>
      <NavLinks>
        {isAdmin ? (
          <>
            <NavLink className='text-white fw-bold' to="/dashboard">Dashboard</NavLink>
           
            <NavLink className='text-white fw-bold' to="/email-configs">Email Configs</NavLink>
            <LogoutButton className='text-danger fw-bold' onClick={handleLogout}>Logout</LogoutButton>
          </>
        ) : (
          <NavLink to="/login">Login</NavLink>
        )}
      </NavLinks>
      <MobileMenu>
        {/* Add mobile menu implementation here */}
      </MobileMenu>
    </Nav>
  );
};

export default Navigation; 